module.exports = __webpack_public_path__ + "media/Rays.898445af.wav";